(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-chart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const toggleButton = document.querySelector(".size-chart-standalone .toggle-product-rings-chart");
    const chartSection = document.querySelector(".size-chart-standalone .product-rings-chart");

    if (toggleButton && chartSection) {
      toggleButton.addEventListener("click", function (e) {
        e.preventDefault();
        if (chartSection.style.display === "none" || chartSection.style.display === "") {
          chartSection.style.display = "block";
          // Smooth scroll to chart when opened
          chartSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          chartSection.style.display = "none";
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
